export const MULTI_REQUEST_REGEX =
  /<!--MULTIREQUEST_LINK_START-->([^]*?)<!--MULTIREQUEST_ID_START-->M?(\d+)<!--MULTIREQUEST_ID_END-->(?:<!--MULTIREQUEST_ID_START-->M?\d+<!--MULTIREQUEST_ID_END-->)*<!--MULTIREQUEST_LINK_END-->/g

export const MULTI_REQUEST_REPLACE_REGEX =
  /<!--MULTIREQUEST_LINK_START-->([^]*?)<!--MULTIREQUEST_ID_START-->(M?)(\d+)<!--MULTIREQUEST_ID_END-->(?:<!--REQUEST_ID_START-->\d+<!--REQUEST_ID_END-->)*<!--MULTIREQUEST_LINK_END-->/g

export const SINGLE_MULTI_REQUEST_REGEX =
  /<!--MULTIREQUEST_ID_START-->(M?\d+)<!--MULTIREQUEST_ID_END--><!--REQUEST_ID_START-->(\d+)<!--REQUEST_ID_END--><!--MULTIREQUEST_LINK_END-->/g

export const REQUEST_LINK_REGEX =
  /<!--REQUEST_LINK_START-->([^]*?)<!--REQUEST_ID_START-->(\d+)<!--REQUEST_ID_END--><!--REQUEST_LINK_END-->/g

export const REQUEST_ID_REGEX = /<!--REQUEST_ID_START-->(\d+)<!--REQUEST_ID_END-->/
